import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Users } from 'lucide-react';

export const Route = createFileRoute('/admin-console/monitoring/engagement')({
    staticData: {
        permissions: ['admin_orgs:read'],
        ui: {
            icon: Users,
            menuDescription: 'Monitor organisation engagement',
        },
    },
    component: () => <Outlet />,
});
